module.exports = __webpack_public_path__ + "img/login_left.4635dbd1.png";